export const input = {
    MB_LEFT: 0,
    MB_RIGHT: 2,
    MB_MIDDLE: 1,
    KEY_CTRL: 17,
    KEY_ALT: 18,
    KEY_SHIFT: 16,
    KEY_SPACE: 32,
    KEY_PGUP: 33,
    KEY_PGDN: 34,
    KEY_LEFT: 37,
    KEY_UP: 38,
    KEY_RIGHT: 39,
    KEY_DOWN: 40,
    KEY_PRINTSCREEN: 44,
    KEY_EQUALS: 61,
    KEY_A: 65,
    KEY_C: 67,
    KEY_D: 68,
    KEY_E: 69,
    KEY_F: 70,
    KEY_H: 72,
    KEY_I: 73,
    KEY_K: 75,
    KEY_L: 76,
    KEY_N: 78,
    KEY_O: 79,
    KEY_P: 80,
    KEY_Q: 81,
    KEY_R: 82,
    KEY_S: 83,
    KEY_V: 86,
    KEY_W: 87,
    KEY_X: 88,
    KEY_Z: 90,
    KEY_PLUS: 107,
    KEY_F1: 112,
    KEY_MINUS: 173,
    KEY_APOSTROPHE: 192,
    KEY_BACK_SLASH: 220,
    KEY_MORE: 190,
    KEY_SLASH: 191,
    KEY_LESS: 188,
    KEY_LEFT_SQUARE_BRACKET: 219,
    KEY_RIGHT_SQUARE_BRACKET: 221,
    KEY_SINGLE_QUOTE: 222
};
//# sourceMappingURL=input.js.map